/* eslint-disable no-undef */
import * as d3 from 'd3';

// Define the div for the tooltip
const div = d3
  .select('body')
  .append('div')
  .attr('class', 'tooltip')
  .style('opacity', 0);

d3.gantt = () => {
  const FIT_TIME_DOMAIN_MODE = 'fit';
  // const FIXED_TIME_DOMAIN_MODE = 'fixed';

  let margin = {
    top: 0,
    bottom: 20,
    right: 40,
    left: 200,
  };

  let timeDomainStart = 1;
  let timeDomainEnd = 100;
  let timeDomainMode = FIT_TIME_DOMAIN_MODE; // fixed or fit
  let taskTypes = [];
  let taskname = [];

  let height = 200;
  let width = 900;
  let x = d3.time.scale().domain([timeDomainStart, timeDomainEnd]).range([0, width]).clamp(true);
  // eslint-disable-next-line max-len
  let y = d3.scale.ordinal().domain(taskTypes).rangeRoundBands([0, height - margin.top - margin.bottom], 0.1);

  const keyFunction = (d) => d.start + d.parent + d.end;

  const rectTransform = (d) => `translate(${x(d.start)},${y(d.parent)})`;

  let xAxis = d3.svg.axis().scale(x).orient('bottom').tickFormat(d3.format())
    .tickSize(8)
    .tickPadding(8);
  let yAxis = d3.svg.axis().scale(y).orient('left').tickSize(0);

  const initTimeDomain = (tasks) => {
    if (timeDomainMode === FIT_TIME_DOMAIN_MODE) {
      if (tasks === undefined || tasks.length < 1) {
        timeDomainStart = 0;
        timeDomainEnd = 0;
        return;
      }
      tasks.sort((a, b) => a.end - b.end);
      timeDomainEnd = tasks[tasks.length - 1].end;
      tasks.sort((a, b) => a.start - b.start);
      // timeDomainStart = tasks[0].start;
      timeDomainStart = 0;
    }
  };

  const initAxis = () => {
    x = d3.scale.linear().domain([0, timeDomainEnd]).range([0, width]);
    // eslint-disable-next-line max-len
    y = d3.scale.ordinal().domain(taskTypes).rangeRoundBands([0, height - margin.top - margin.bottom], 0.1);

    xAxis = d3.svg
      .axis()
      .scale(x)
      .orient('bottom')
      .ticks(30)
      .tickFormat(d3.format())
      .tickSize(-height, 0, 1)
      .tickPadding(8);
    // .tickFormat(function(d) { return d + 1; });

    yAxis = d3.svg
      .axis()
      .scale(y)
      .orient('left')
      .tickSize(2);
  };

  const gantt = (tasks) => {
    initTimeDomain(tasks);
    initAxis();

    const svg = d3.selectAll('.svg')
      .append('svg')
      .attr('class', 'chart')
      .attr('width', width + margin.left + margin.right)
      .attr('height', height + margin.top + margin.bottom)
      .append('g')
      .attr('class', 'gantt-chart')
      .attr('width', width + margin.left + margin.right)
      .attr('height', height + margin.top + margin.bottom)
      .attr('transform', `translate(${margin.left}, ${margin.top})`);

    svg.append('g')
      .attr('class', 'x axis')
      .attr('transform', `translate(0, ${height - margin.top - margin.bottom})`)
      .transition()
      .attr('opacity', 0.3)
      .call(xAxis);

    svg.append('g')
      .attr('class', 'y axis')
      .attr('opacity', 0.3)
      .transition()
      .call(yAxis);

    svg.selectAll('.chart')
      .data(tasks, keyFunction)
      .enter()
      .append('rect')
      .attr('rx', 5)
      .attr('ry', 5)
      .attr('fill', (d) => taskname[d.name])
      .attr('opacity', 0.9)
      .on('mouseover', (d) => {
        d3.select(this)
          .style('opacity', 1);

        div.transition()
          .duration(200)
          .style('opacity', 0.9);

        div.html(`
          Distribución: <b>${d.name}</b>
          <br>
          Rango: <b>( ${d.start} - ${d.end} ) </b> `)
          .style('left', `${d3.event.pageX}px`)
          .style('top', `${d3.event.pageY}px`);
      })

      .on('mouseout', () => {
        div.transition()
          .duration(500)
          .style('opacity', 0);
        d3.select(this).style('opacity', 0.9);
      })

      .attr('y', 0)
      .attr('transform', rectTransform)
      .attr('height', () => y.rangeBand())
      .attr('width', (d) => {
        const w = x(d.end) - x(d.start);
        return w || 6;
      });

    return gantt;
  };

  gantt.redraw = (tasks) => {
    initTimeDomain(tasks);
    initAxis();

    const svg = d3.select('svg');

    const ganttChartGroup = svg.select('.gantt-chart');
    const rect = ganttChartGroup.selectAll('rect').data(tasks, keyFunction);

    rect.enter()
      .insert('rect', ':first-child')
      .attr('rx', 5)
      .attr('ry', 5)
      .attr('fill', (d) => taskname[d.name])

      .on('mouseover', (d) => {
        d3.select(this).style('opacity', 1);
        div.transition()
          .duration(200)
          .style('opacity', 0.9);
        div.html(
          `${d.name}<br/>`
          + `Inicio: ${d.start}<br/>`
          + `Fin: ${d.end}<br/>`,
        )
          .style('left', `${d3.event.pageX}px`)
          .style('top', `${d3.event.pageY}px`);
      })

      .on('mouseout', () => {
        div.transition()
          .duration(500)
          .style('opacity', 0);
        d3.select(this).style('opacity', 0.9);
      })

      .transition()
      .attr('y', 0)
      .attr('transform', rectTransform)
      .attr('height', () => y.rangeBand())

      .attr('width', (d) => (x(d.end) - x(d.start)));

    rect.transition()
      .attr('transform', rectTransform)
      .attr('height', () => y.rangeBand())
      .attr('width', (d) => (x(d.end) - x(d.start)));

    rect.exit().remove();

    svg.select('.x').transition().call(xAxis);
    svg.select('.y').transition().call(yAxis);

    return gantt;
  };

  gantt.margin = (value) => {
    if (!arguments.length) return margin;
    margin = value;
    return gantt;
  };

  gantt.timeDomain = (value) => {
    if (!arguments.length) return [timeDomainStart, timeDomainEnd];
    timeDomainStart = +value[0];
    timeDomainEnd = +value[1];
    return gantt;
  };

  gantt.timeDomainMode = (value) => {
    if (!arguments.length) return timeDomainMode;
    timeDomainMode = value;
    return gantt;
  };

  gantt.taskTypes = (value) => {
    if (!arguments.length) return taskTypes;
    taskTypes = value;
    return gantt;
  };

  gantt.taskname = (value) => {
    if (!arguments.length) return taskname;
    taskname = value;
    return gantt;
  };

  gantt.width = (value) => {
    if (!arguments.length) return width;
    width = +value;
    return gantt;
  };

  gantt.height = (value) => {
    if (!arguments.length) return height;
    height = +value;
    return gantt;
  };

  return gantt;
};

export default d3;
